import jwtDecode from 'jwt-decode'

export default function tryJwtDecode<T>(...args: Parameters<typeof jwtDecode>) {
  try {
    return jwtDecode<T>(...args)
  } catch (error) {
    return null
  }
}
